import script from "./station.details.form.vue?vue&type=script&lang=ts&setup=true"
export * from "./station.details.form.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__